"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("./utils");

require("./Saturation.scss");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Saturation = function Saturation(_ref) {
  var _ref$hsl = _ref.hsl,
      hsl = _ref$hsl === void 0 ? {} : _ref$hsl,
      _ref$hsv = _ref.hsv,
      hsv = _ref$hsv === void 0 ? {} : _ref$hsv,
      onChange = _ref.onChange;
  var container = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    return function () {
      return unbindEventListeners();
    };
  }, []);

  function getContainerRenderWindow() {
    var renderWindow = window;

    while (!renderWindow.document.contains(container.current) && renderWindow.parent !== renderWindow) {
      renderWindow = renderWindow.parent;
    }

    return renderWindow;
  }

  var handleChange = function handleChange(e) {
    typeof onChange === 'function' && onChange((0, _utils.calculateSaturationChange)(e, hsl, container.current), e);
  };

  var handleMouseDown = function handleMouseDown(e) {
    handleChange(e);
    var renderWindow = getContainerRenderWindow();
    renderWindow.addEventListener('mousemove', handleChange);
    renderWindow.addEventListener('mouseup', handleMouseUp);
  };

  var handleMouseUp = function handleMouseUp() {
    unbindEventListeners();
  };

  function unbindEventListeners() {
    var renderWindow = getContainerRenderWindow();
    renderWindow.removeEventListener('mousemove', handleChange);
    renderWindow.removeEventListener('mouseup', handleMouseUp);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-cp-saturation",
    ref: container,
    onMouseDown: handleMouseDown,
    onTouchMove: handleChange,
    onTouchStart: handleChange,
    style: {
      background: "hsl(".concat(hsl.h, ",100%, 50%)")
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "saturation-white"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "saturation-black"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-cps-pointer",
    style: {
      top: "".concat(-(hsv.v * 100) + 100, "%"),
      left: "".concat(hsv.s * 100, "%")
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-cps-circle",
    style: {
      backgroundColor: "hsl(".concat(hsl.h, ", ").concat(hsl.s * 100, "%, ").concat(hsl.l * 100, "%)")
    }
  }))));
};

var _default = Saturation;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/ColorPicker/Saturation.js
// module id = 1896
// module chunks = 0